import { render } from "./AccountDetails.vue?vue&type=template&id=ec36535a&scoped=true"
import script from "./AccountDetails.vue?vue&type=script&lang=js"
export * from "./AccountDetails.vue?vue&type=script&lang=js"

import "./AccountDetails.vue?vue&type=style&index=0&id=ec36535a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec36535a"]])

export default __exports__